// extracted by mini-css-extract-plugin
export default {"sliderContainer":"ArticlesTemplatesSlider_sliderContainer__HBQHV","sliderItem":"ArticlesTemplatesSlider_sliderItem__FM6aK","dots":"ArticlesTemplatesSlider_dots__Jb9FQ"};